// @ts-expect-error
import theme from '../../styles/theme.css?inline';

// More on how to set up stories at: https://storybook.js.org/docs/html/writing-stories/introduction
export default {
  title: 'Components/Form',
  tags: ['autodocs'],
  render: args => {
    return `
      <hr-widget url="${args.url}" token="${args.token}" resource="${args.resource}"></hr-widget>
      <hr-form mode="${args.mode}"></hr-form>
      <script>
        document.querySelector('hr-form').classes = JSON.parse('${JSON.stringify(args.classes ? args.classes : null)}');
      </script>
    `;
  },
  argTypes: {
    token: { control: 'text' },
    resource: { control: 'text' },
    url: { control: 'text' },
    mode: { control: 'select', options: ['modal'] },
    classes: { control: 'object' },
  },
  args: {
    url: 'http://localhost:4000',
    token: '2c0437fd-eb89-47f5-b472-5d901bedfe6c',
    resource: 'storybook-primary',
    onReaction: event => {
      console.log('ON REACTION', event.detail);
    },
  },
  decorators: [
    story => `
    <style>${theme}</style>
    ${story()}
  `,
  ],
};

export const Primary = {};

export const Classes = {
  args: {
    classes: {
      root: 'root-class',
      container: 'container-class',
      containerVisible: 'container-visible-class',

      // success
      success: 'success-class',
      successIcon: 'success-icon-class',
      successContent: 'success-content-class',

      // content
      content: 'content-class',
      contentBefore: 'content-before-class',
      contentAfter: 'content-after-class',

      // form
      form: 'form-class',
      formHeader: 'form-header-class',
      formErrorsList: 'form-errors-list-class',
      formErrorItem: 'form-error-item-class',
      formFooter: 'form-footer-class',

      // submit
      submit: 'submit-class',
      submitIdle: 'submit-idle-class',
      submitLoading: 'submit-loading-class',

      // field
      field: 'field-class',
      label: 'label-class',
      labelText: 'label-text-class',
      input: 'input-class',
      inputHint: 'input-hint-class',
      inputError: 'input-error-class',

      // text input
      inputText: 'input-text-class',
    },
  },
};

export const Modal = {
  args: {
    mode: 'modal',
    classes: {
      root: 'modal-form',
    },
  },
};
